// extracted by mini-css-extract-plugin
export var chip = "_fc-0";
export var filterDropdown = "_fc-5";
export var filterItem = "_fc-6";
export var icon = "_fc-1";
export var removeButton = "_fc-3";
export var removeIcon = "_fc-4";
export var separator = "_fc-2";